<template>
    <div class="footer">
        <div class="container">
            <!-- <div class="footerTop clearfix">
                <div class="logo">
                    <img src="../../assets/images/public/logo.png" />
                </div>
                <div class="info">
                    <dl>
                        <dt>联系我们</dt>
                        <dd>E-mail：xtsz@cermtm.com</dd>
                        <dd>CERM项目咨询电话：010-53391240/1241</dd>
                        <dd>邮码：100024</dd>
                        <dd>地址：北京市朝阳区常慧路6号V中心B座1407室</dd>
                    </dl>
                    <dl>
                        <dt>关于我们</dt>
                        <dd><router-link to="/service">服务协议</router-link></dd>
                        <dd><router-link to="/helpCenter">帮助中心</router-link></dd>
                    </dl>
                </div>
            </div> -->
            <div class="footerBottom">
                <div class="container" v-html="description"></div>
				<!-- <p>技术支持：北京创富阳光网络科技有限公司</p> -->
            </div>
        </div>
    </div>
</template>

<script>
    import { listByType } from '@/api/cms'
    export default {
        name: "myFooter",
        data() {
            return {
                description: '' 
            }
        },
        props:{
            
        },
        mounted(){
            listByType('index_footer').then(res => {
                if(res.length){
                    this.description = res[0].description
                }
            })
        },
        methods:{
            
        }
    }
</script>

<style scoped>
    .footer{}
    .footer>.container{border-top: 4px solid #bb301f;}
    .footerTop{padding:30px 0;border-bottom: 1px solid #bfbfbf;}
    .logo{width: 178px;height: 30px;margin-top: 30px;margin-left: 98px;float: left;}
    .logo img{display: block;width: 100%;height: 100%;}
    .info{float: left;margin-left: 150px;overflow: hidden;}
    .info dl{float: left;margin-right: 100px;}
    .info dl dt{font-size: 14px;color: #000000;line-height: 14px;margin-bottom: 14px;font-weight: 600;}
    .info dl dd{font-size: 12px;color: #000000;line-height: 24px;}
    .footerBottom{font-size: 12px;color: #000;padding: 14px 0;text-align: center;line-height: 24px;}
</style>